<template>
  <account-template-form
    :init-template="template"
    :submit-action="createTemplate"
    :success-msg="t('templateCreated')"
    :enable-clear-form="true"
    :clear-form-on-submit="true"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AccountTemplateForm from './AccountTemplateForm.vue'
import { AccountTemplate } from '@/models/accounting/AccountTemplate'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-account-template',

  components: {
    AccountTemplateForm
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          templateCreated: 'Account created successfully'
        },
        ar: {
          templateCreated: 'تم إنشاء الحساب بنجاح وتم إنشاء الحسابات'
        }
      }
    })

    return { t }
  },

  data() {
    return {
      template: new AccountTemplate()
    }
  },

  methods: {
    async createTemplate(template: AccountTemplate) {
      try {
        await this.$http.post(AccountTemplate.ENDPOINT, template)
        await this.$router.push(this.$Route.ACCOUNTING_ACCOUNTS)
        return null
      } catch (error) {
        return error
      }
    }
  }
})
</script>
